window.Popup = {

	beforeNavScroll: null,
	popupTimer: null,

	isVisible: false,
	modifier: [],

	show: function(id, modifier) {
		
		// Replace the content
		var content = $("#popup-" + id).html();

		Popup.clearModifiers();

		if (modifier) {
			$(".popup__container").addClass("popup__container--" + modifier);
		}

		window.Popup.showPopup(content, id);

		if (modifier) {
			Popup.modifier.push(modifier);
		}
	},

	showPopup: function(content, id) {
		$(".popup__content").html(content);

		window.Popup.beforeNavScroll = $(window).scrollTop();
		window.history.pushState(id, id, '#' + id);

		$(document.body).addClass("popup-visible");

		window.Popup.popupTimer = setTimeout(function() {
			$(document.body).addClass("popup-visible-fix");
		}, 300);

		window.Popup.isVisible = true;
	},

	showMessage: function(message)
	{

		var title   = message["title"];
		var icon    = message["type"] ? message["type"] : "default";
		var content = message["message"];

		var markup = [];


        if (title) {
	        markup.push('<div class="popup__title">');
	        markup.push('<h3>' + title + '</h3>');
	        markup.push('</div>');
        }
            
        markup.push('<div class="popup__message">');
        markup.push('<div class="popup__icon popup__icon--' + icon + '"></div>');
        markup.push(content);
        markup.push('</div>');

        markup = markup.join("");

        Popup.clearModifiers();
        window.Popup.showPopup(markup, "message");

	},

	hide: function(e) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}

		if (window.Popup.isVisible) {

			if ($(document.body).hasClass("popup-message-visible")) {
				$(document.body).removeClass("popup-message-visible");
				window.Popup.onBack();
			}
			else {
				history.back();
			}
		}


	},

	clearModifiers: function() {
		var container = $(".popup__container");
		var popup = $(".popup");
		var modifier;

		popup.attr("class", "popup");

		while (modifier = window.Popup.modifier.shift())
		{
			container.removeClass("popup__container--" + modifier);
		}
	},

	// pop from history
	onBack: function(e) {

		if ($(document.body).hasClass("popup-visible") || 
			$(document.body).hasClass("popup-visible-fix")) 
		{
			clearTimeout(window.Popup.popupTimer);

			
			$(document.body).removeClass("popup-visible");
			$(document.body).removeClass("popup-visible-fix");
			
			Popup.clearModifiers();

			if ($(window).width() < 980) {
				$(window).scrollTop(window.Popup.beforeNavScroll);
			}

			Popup.isVisible = false;
		}

	},

	init: function() {

		$(window).on("popstate", Popup.onBack);

		$(document).on("keydown", function(e) {
			// escape key
			if (window.Popup.isVisible && e.which === 27) {
				window.Popup.hide();
			}
		});

		$(document).on("click", ".popup__container", function(e) {
			e.stopPropagation();
		});

		$(document).on("click", ".popup", Popup.hide);

		if ($(document.body).hasClass("popup-message-visible")) {
			window.Popup.isVisible = true;
		}

	}

}

Popup.init();


// WEBPACK FOOTER //
// ./resources/assets/js/ui/popup.js